export enum Mode {
  RESTING,
  OVERLAY,
  HOVER,
}
